
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/help-center",
      function () {
        return require("private-next-pages/docs/help-center.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/help-center"])
      });
    }
  